import { Database } from "@/integrations/supabase/types";
import { QueryObserverResult } from "@tanstack/react-query";
import * as z from "zod";

export const formSchema = z.object({
  name: z.string().optional(),
  role: z.string(),
  title: z.string().optional(),
  country: z.string().optional(),
  seniority: z.string().optional(),
  specialty: z.string().optional(),
  salary: z.string().optional(),
  timezone: z.string().optional(),
  availableFrom: z.string().optional(),
  availableTo: z.string().optional(),
  jobTypes: z.array(z.string()),
  email: z.string().email("Invalid email address").optional(),
  githubUrl: z.union([z.string().url("Invalid URL"), z.string().length(0)]).optional(),
  linkedinUrl: z.union([z.string().url("Invalid URL"), z.string().length(0)]).optional(),
});

export type FormValues = z.infer<typeof formSchema>;

export interface PersonalDetailsModalProps {
  refetchSection: ()=>Promise<QueryObserverResult<unknown, unknown>>;
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  currentDetails?: Database['public']['Tables']['developer_profiles']['Row'];
}